import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyComponent } from './privacy.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MatDialogModule } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { createTranslateLoader } from '../../http-loader-factory';
import { CustomPipeModule } from '../../../shared/pipes/custom-pipe.module';
import { LoaderModule } from '../../components/loader/loader.module';

@NgModule({
    imports: [
        CommonModule,
        MatDialogModule,
        CustomPipeModule,
        TranslateModule.forChild({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient],
            },
        }),
        LoaderModule,
    ],
  declarations: [PrivacyComponent],
  exports: [PrivacyComponent],
})
export class PrivacyModule {}
